


const SubHeading = ({children}) => {
    return (
      <p className="text-2xl sm:text-4xl font-semibold text-gray-400 ">{children}</p>
     );
  };
  
  export default SubHeading;
  